"use client";

import { BSRCommunication } from "./bsr/BSRCommunication";
import { ChatBubble as LegacyChatBubble } from "./legacy/ChatBubble";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";

export const ChatBubble = createBSRExperimentIcon(
  LegacyChatBubble,
  BSRCommunication
);
